import $ from 'jquery';
import { readableOnWhite } from '../../common/js/readableColor';

const triviaObject = {
  methods: {
    addTextColor: function () {
      // Authored question colour, made readable and matched to the site
      // palette (e.g. #00adef becomes #0c73b4; WCAG 1.4.3)
      $('.trivia__section__title').each(function () {
        const color = $(this).attr('data-color');
        if (color) {
          $(this).css('color', readableOnWhite(color));
        }
      });
      $('.trivia__section__wrapper').css('border-color', $('.trivia__section__wrapper').attr('data-borderColor'));
    },
    dataLayerObj : function(e, el, pageSection) {
      var obj = {
          'articleName' : "",
          'blogCategory' : "",
          'blogPageCategory' : "",
          'buttonText' : e ? e.replace(/\n/g, '').trim():"",
          'pageSection' : pageSection ? pageSection : "Banner",
          'productCategory' : "",
          'productName' : "",
          'question' : "",
          'searchTerm' : "",
          'videoTitle' : "",
          'bannerName' : el+" Banner",
          'bannerType' : el+" Banner"
      };
      return obj;
  },
    init: function () {
      this.addTextColor();
      $(".trivia a").on('click', function(e){
        if(e.currentTarget.hasAttribute('href')){
          let text = e.currentTarget.getElementsByTagName('img')[0].getAttribute('alt');
          var obj = triviaObject.methods.dataLayerObj(text, text+"_Middle_Type1", "Middle_Type1");
          createDataLayer('bannerClick', obj);
      }
      });
    }
  }
};

$(() => {
  if ($(".trivia__section").length > 0) {
    triviaObject.methods.init();
  }
});
